// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1582517a","821":"d8c25b64"}[chunkId] + ".chunk.js";
};